import React from 'react';
import { fontFrame } from '../../../styles/mixin/font';
import styled from '@emotion/styled';
import { BLACK } from '../../../styles/constants/color';

const TitleElement = styled.h1`
  ${fontFrame('500', '21px', '1', BLACK)}
  margin-bottom: 25px;
  text-align: center;
`;

interface Props {
  text: string;
}

/**
 * @descritpion 컴포넌트의 제목 컴포넌트
 * @param {string} text 제목 text
 *  */
function Title({ text }: Props): JSX.Element {
  return <TitleElement>{text}</TitleElement>;
}

export default Title;
